import React, { useCallback, useState, useEffect } from "react";
import { BsSearch } from "react-icons/bs";
import { HiTable } from "react-icons/hi";
import { FaIndustry } from "react-icons/fa";
import "../../ui/components/mensal/mensal.css";
import {
  GetMensal,
  GetMensalByForn,
  GetSupplierUnitsByUser,
} from "../../data/services";
import { GetYearsArry } from "../../helpers/helpers";
import { useAuth } from "../../context/auth";

const Mensal: React.FC = () => {
  const { user } = useAuth();

  const profile = user?.profile;
  const idUsuario = user?.idUsuario;
  const idFabrica = user?.idFabrica;

  const [open, setOpen] = useState<boolean>(false);
  const [openT, setOpenT] = useState(false);
  const [openSede, setOpenSede] = useState(false);
  const [mensal, setMensal] = useState<any[]>([]);
  const [embalagem, setEmbalagem] = useState("");
  const [dataMensal, setDataMensal] = useState<any[]>([]);
  const [dataForn, setDataForn] = useState<any[]>([]);
  const [year, setYear] = useState<any>("0");
  const [anosPesquisa, setAnosPesquisa] = React.useState<number[]>([]);

  const resetView = useCallback(() => {
    setOpen(false);
    setOpenT(false);
    setOpenSede(false);
    setDataMensal([]);
    setDataForn([]);
  }, []);

  const openTable = useCallback(
    (item: any, openVal: boolean) => {
      item.open = openVal;

      const filterALLUnidades = dataMensal?.filter((dm: any) => {
        return (
          dm?.fornecedor_unidade_descricao ===
          item?.fornecedor_unidade_descricao
        );
      });

      item.data = filterALLUnidades;

      setDataForn((prev) => [...prev]);
    },
    [dataMensal]
  );

  const openAllSede = useCallback(
    (item: any, openVal: boolean) => {
      item.openSede = openVal;

      const filterUnidades = dataMensal?.filter((dm: any) => {
        return dm?.fornecedor_descricao === item?.fornecedor_descricao;
      });

      function getObjectsWithDifferentFornecedorDescricaoUnidade(
        array: { id: number; fornecedor_unidade_descricao: string }[]
      ): { id: number; fornecedor_unidade_descricao: string }[] {
        const unique = Array.from(
          new Set(array.map((obj) => obj.fornecedor_unidade_descricao))
        );
        const out: { id: number; fornecedor_unidade_descricao: string }[] = [];
        unique.forEach((descricao) => {
          const objects = array.filter(
            (obj) => obj.fornecedor_unidade_descricao === descricao
          );
          if (objects.length > 0) out.push(objects[0]);
        });
        return out;
      }

      const unidadesForn =
        getObjectsWithDifferentFornecedorDescricaoUnidade(filterUnidades);
      item.unidades = unidadesForn;

      setDataForn((prev) => [...prev]);
    },
    [dataMensal]
  );

  useEffect(() => {
    const load = async () => {
      try {
        if (!profile) return;

        setAnosPesquisa(GetYearsArry(new Date().getFullYear(), 7));

        if (profile === "usuarioFornecedor") {
          if (!idUsuario) return;

          const resp: any = await GetSupplierUnitsByUser(idUsuario);
          console.log("🚀 ~ resp:", resp);

          const rows = Array.isArray(resp?.data)
            ? resp.data
            : Array.isArray(resp)
            ? resp
            : [];

          let idFornecedorToUse: any = null;

          if (idFabrica) {
            const match = rows.find(
              (r: any) => String(r.idUnidade) === String(idFabrica)
            );
            idFornecedorToUse = match?.idFornecedor ?? null;
          }

          if (!idFornecedorToUse && rows.length > 0) {
            idFornecedorToUse = rows[0]?.idFornecedor;
          }

          if (!idFornecedorToUse) {
            console.error(
              "Não achei idFornecedor via unidades-por-usuario. idUsuario:",
              idUsuario,
              "rows:",
              rows
            );
            setMensal([]);
            return;
          }

          GetMensalByForn(setMensal, idFornecedorToUse);
          return;
        }

        if (profile === "usuarioColaborador" || profile === "superAdmin") {
          GetMensal(setMensal);
          return;
        }

        console.warn("Perfil não reconhecido:", profile);
        setMensal([]);
      } catch (err) {
        console.error("Erro ao carregar Mensal:", err);
        setMensal([]);
      }
    };

    load();
  }, [profile, idUsuario, idFabrica]);

  const SearchItem = useCallback(() => {
    resetView();

    const filter = mensal.filter(
      (item: any) => item.tipo_embalagem === embalagem
    );

    const filterByYear = filter.filter(
      (item: any) => String(item.ano) === String(year)
    );

    setDataMensal(filterByYear);

    function getObjectsWithDifferentFornecedorDescricao(
      array: { id: number; fornecedor_descricao: string }[]
    ): { id: number; fornecedor_descricao: string }[] {
      const unique = Array.from(
        new Set(array.map((obj) => obj.fornecedor_descricao))
      );
      const out: { id: number; fornecedor_descricao: string }[] = [];
      unique.forEach((descricao) => {
        const objects = array.filter(
          (obj) => obj.fornecedor_descricao === descricao
        );
        if (objects.length > 0) out.push(objects[0]);
      });
      return out;
    }

    const res = getObjectsWithDifferentFornecedorDescricao(filterByYear);

    setDataForn(res);
    setOpen(true);
  }, [embalagem, mensal, year, resetView]);

  function getDifferentsEmbalagens(
    array: { id: number; tipo_embalagem: string }[]
  ) {
    const unique = Array.from(new Set(array.map((obj) => obj.tipo_embalagem)));
    const out: { id: number; tipo_embalagem: string }[] = [];
    unique.forEach((descricao) => {
      const objects = array.filter((obj) => obj.tipo_embalagem === descricao);
      if (objects.length > 0) out.push(objects[0]);
    });
    return out;
  }

  const embalagens = getDifferentsEmbalagens(mensal);

  // média
  const toNumber = (v: any) => {
    if (v === null || v === undefined) return null;
    const n = Number(String(v).replace(",", "."));
    return Number.isFinite(n) ? n : null;
  };

  const avgFromData = (data: any[], key: string) => {
    const nums = (data || [])
      .map((row) => toNumber(row?.[key]))
      .filter((n): n is number => n !== null);

    if (nums.length === 0) return null;

    const sum = nums.reduce((acc, n) => acc + n, 0);
    return sum / nums.length;
  };

  const format2 = (n: number | null) => {
    if (n === null) return "-";
    return n.toFixed(2);
  };

  useEffect(() => {
    resetView();
  }, [year, embalagem, resetView]);

  return (
    <div>
      <div>
        <h1>PQMF - Mensal</h1>
      </div>

      <div
        style={{
          display: "flex",
          width: "100%",
          border: "1px solid #d4d4d5",
          padding: "10px 15px",
          borderRadius: 4,
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div style={{ display: "flex", alignItems: "center", width: "80%" }}>
          <div
            style={{ display: "flex", flexDirection: "column", width: "50%" }}
          >
            <label style={{ marginRight: 15, color: "#555555", width: "100%" }}>
              Ano
            </label>
            <select
              id="statusSelect"
              className="select-defect"
              style={{ outline: "none", width: "100%" }}
              value={year}
              onChange={(e) => setYear(e.target.value)}
            >
              <option value="0">Selecione</option>
              {anosPesquisa.map((item: any) => (
                <option key={item} value={item}>
                  {item}
                </option>
              ))}
            </select>
          </div>

          <div
            style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              marginLeft: "20px",
            }}
          >
            <label style={{ marginRight: 15, color: "#555555", width: "100%" }}>
              Grupo de Embalagem
            </label>
            <select
              id="statusSelect"
              name=""
              className="select-defect"
              style={{ outline: "none", width: "70%" }}
              value={embalagem}
              onChange={(e) => setEmbalagem(e.target.value)}
            >
              <option value="">Selecione</option>
              {embalagens
                .sort((a: any, b: any) =>
                  a.tipo_embalagem.localeCompare(b.tipo_embalagem)
                )
                .map((item: any) => (
                  <option value={item.tipo_embalagem} key={item.tipo_embalagem}>
                    {item.tipo_embalagem}
                  </option>
                ))}
            </select>
          </div>
        </div>

        <div style={{ display: "flex", height: 40, justifyContent: "end" }}>
          <button
            className="button-defect-search"
            onClick={() => SearchItem()}
            disabled={year === "0" || !embalagem}
          >
            <BsSearch style={{ marginRight: 10 }} />
            Pesquisar
          </button>
        </div>
      </div>

      {open && (
        <div className="content-info-mensal">
          <div className="container-info-mensal">
            <div
              style={{
                background: "#f3f4f5",
                border: "1px solid #d4d4d5",
                padding: "1rem 1rem",
                borderRadius: 4,
              }}
            >
              <h1
                style={{
                  fontSize: 14,
                  display: "flex",
                  alignItems: "center",
                  margin: 0,
                }}
              >
                <HiTable
                  color="rgba(163, 142, 23, 0.8)"
                  size={25}
                  style={{ marginRight: 10 }}
                />
                Fornecedor | Planta | Indicador
              </h1>
            </div>

            <div
              style={{
                border: "1px solid #d4d4d5",
                borderRadius: 4,
                marginTop: 15,
              }}
            >
              <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                {dataForn.map((item: any) => (
                  <li
                    key={item.fornecedor_descricao}
                    className="list-style-mensal"
                  >
                    <div
                      className="title-name-sede"
                      onClick={() => {
                        setOpenSede(!openSede);
                        openAllSede(
                          item,
                          item.openSede ? !item.openSede : true
                        );
                      }}
                    >
                      <FaIndustry
                        color="rgba(163, 142, 23, 0.8)"
                        style={{ marginRight: 10 }}
                      />
                      {item.fornecedor_descricao}
                    </div>

                    {item.openSede && (
                      <ul style={{ listStyle: "none", paddingLeft: 0 }}>
                        {item.unidades.map((sd: any) => (
                          <li
                            key={sd.fornecedor_unidade_descricao}
                            className="list-sede"
                          >
                            <p
                              className="name-sede"
                              onClick={() => {
                                setOpenT(!openT);
                                openTable(sd, sd.open ? !sd.open : true);
                              }}
                            >
                              <li>{sd.fornecedor_unidade_descricao}</li>
                            </p>

                            {sd.open && (
                              <div>
                                <table className="table-sede">
                                  <thead className="table-head">
                                    <tr>
                                      <th>Indicador</th>

                                      {sd.data.map((it: any) => (
                                        <th
                                          key={`${it.id_fechamento}-${it.mes_abv}`}
                                        >
                                          {it.mes_abv}
                                        </th>
                                      ))}

                                      <td className="header-total">Total</td>
                                    </tr>
                                  </thead>

                                  <tbody className="table-body">
                                    <tr>
                                      <td>
                                        <div className="pqmf">PQMF</div>
                                      </td>

                                      {sd.data.map((info: any, idx: number) => (
                                        <td key={`pqmf-${idx}`}>{info.pqmf}</td>
                                      ))}

                                      <td>
                                        {format2(avgFromData(sd.data, "pqmf"))}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Performance de Qualidade</td>
                                      {sd.data.map((info: any, idx: number) => (
                                        <td key={`pq-${idx}`}>{info.pq}</td>
                                      ))}
                                      <td>
                                        {format2(avgFromData(sd.data, "pq"))}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Devolutivas de NCEs</td>
                                      {sd.data.map((info: any, idx: number) => (
                                        <td key={`de-${idx}`}>{info.de}</td>
                                      ))}
                                      <td>
                                        {format2(avgFromData(sd.data, "de"))}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Qualificação</td>
                                      {sd.data.map((info: any, idx: number) => (
                                        <td key={`qa-${idx}`}>{info.qa}</td>
                                      ))}
                                      <td>
                                        {format2(avgFromData(sd.data, "qa"))}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Logística</td>
                                      {sd.data.map((info: any, idx: number) => (
                                        <td key={`lg-${idx}`}>{info.lg}</td>
                                      ))}
                                      <td>
                                        {format2(avgFromData(sd.data, "lg"))}
                                      </td>
                                    </tr>

                                    <tr>
                                      <td>Comercial</td>
                                      {sd.data.map((info: any, idx: number) => (
                                        <td key={`cm-${idx}`}>{info.cm}</td>
                                      ))}
                                      <td>
                                        {format2(avgFromData(sd.data, "cm"))}
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            )}
                          </li>
                        ))}
                      </ul>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Mensal;
